import SectionHeading from "./SectionHeading";
import { plotBeats } from "@/mocks/movieContent";

export default function PlotSection() {
  return (
    <section id="plot" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <SectionHeading
          eyebrow="剧情介绍"
          title="剧情介绍：一段关系是如何一步步发生变化的"
          description="下面把影片的叙事大致拆成五个阶段。这样看，你会更容易理解它为什么“慢”，以及情绪是如何被一点点累积起来的。"
          icon="ri-book-open-line"
        />

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-8 lg:gap-12">
          <ol className="relative">
            {plotBeats.map((beat, index) => (
              <li key={beat.phase} className="relative flex gap-4 md:gap-6 pb-8 last:pb-0">
                <div className="flex flex-col items-center">
                  <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading font-semibold">
                    {beat.phase}
                  </span>
                  {index < plotBeats.length - 1 && (
                    <span className="w-px flex-1 bg-background-300 mt-2"></span>
                  )}
                </div>
                <div className="pt-1.5">
                  <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">{beat.title}</h3>
                  <p className="mt-2 text-sm md:text-base text-foreground-700 leading-relaxed">{beat.text}</p>
                </div>
              </li>
            ))}
          </ol>

          <aside className="lg:sticky lg:top-24 self-start">
            <div className="w-full h-64 md:h-80 rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=empty%20city%20street%20at%20night%20after%20rain%2C%20reflections%20of%20warm%20shop%20lights%20on%20wet%20pavement%2C%20lonely%20cinematic%20atmosphere%2C%20deep%20shadows%2C%20soft%20film%20grain%2C%20warm%20amber%20and%20crimson%20color%20grading%2C%20editorial%20photography%2C%20elegant%20and%20moody&width=900&height=1200&seq=hap-plot-01&orientation=portrait"
                alt="雨后夜晚的街道与暖色灯光，呼应剧情中克制又暧昧的氛围"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="mt-4 rounded-lg border border-background-200 bg-background-50 p-4">
              <div className="flex items-center gap-2 text-primary-600">
                <i className="ri-lightbulb-line"></i>
                <span className="text-sm font-medium">一句话看懂</span>
              </div>
              <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
                它不是靠情节反转取胜，而是把“关系的变化”当成主线：从靠近到克制，再到不得不做出选择。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}